import { Container } from "@chakra-ui/react"

import { Page } from "../components/Page"

export function NoMatch() {
  return (
    <Page>
      <Container>Not Found!</Container>
    </Page>
  )
}
